export default __webpack_public_path__ + "static/media/Ficha Técnica - Suco de Limão.d00eb83f.pdf";